var _rect, _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAppStore(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 256,
    height: 256,
    viewBox: "0 0 256 256",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 24,
    y: 24,
    width: 208,
    height: 208,
    rx: 61,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M65 144.267C65 140.249 68.2545 136.992 72.2692 136.992H130.423C134.438 136.992 137.692 140.249 137.692 144.267C137.692 148.285 134.438 151.542 130.423 151.542H72.2692C68.2545 151.542 65 148.285 65 144.267Z",
    fill: "#141414"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M142.538 144.267C142.538 140.249 145.793 136.992 149.808 136.992H183.731C187.745 136.992 191 140.249 191 144.267C191 148.285 187.745 151.542 183.731 151.542H149.808C145.793 151.542 142.538 148.285 142.538 144.267Z",
    fill: "#141414"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M68.8723 184.024C65.3954 182.015 64.2042 177.566 66.2115 174.087L75.5828 157.843C77.5902 154.363 82.0359 153.171 85.5128 155.18C88.9896 157.189 90.1808 161.638 88.1735 165.117L78.8022 181.361C76.7949 184.841 72.3491 186.033 68.8723 184.024Z",
    fill: "#141414"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M97.9492 130.676C94.4724 128.667 93.2811 124.218 95.2885 120.738L129.96 60.6386C131.968 57.1591 136.413 55.967 139.89 57.9759C143.367 59.9847 144.558 64.4339 142.551 67.9134L107.879 128.013C105.872 131.492 101.426 132.684 97.9492 130.676Z",
    fill: "#141414"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M181.418 183.265C177.942 185.274 173.496 184.081 171.488 180.602L106.596 68.1184C104.588 64.6389 105.78 60.1897 109.256 58.1808C112.733 56.1719 117.179 57.3641 119.186 60.8436L184.079 173.327C186.086 176.807 184.895 181.256 181.418 183.265Z",
    fill: "#141414"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAppStore);
export default __webpack_public_path__ + "static/media/app-store.bba7b2aab2782cbeb9082485699022e3.svg";
export { ForwardRef as ReactComponent };